import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: 'Extra {{percentageAmount}}% off',
  [OfferKindEnum.PercentageOffByProducts]: 'Extra {{percentageAmount}}% off',
  [OfferKindEnum.AmountOffByProducts]: 'Extra {{amount}} off',
  [OfferKindEnum.Bogo]: 'Buy 1, get 1 free',
  [OfferKindEnum.BogoHalfPrice]: 'Buy 1 get 1 half price!',
  [OfferKindEnum.FreeItemByProducts]: 'Free item',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Free item',
};

export default OfferBadge;
